
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42.148","height":"42.129"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1457","transform":"translate(-16751.852 4207.558)"}},[_c('rect',{attrs:{"data-name":"Rectangle 60","width":"42.148","height":"42.129","rx":"5","transform":"translate(16751.852 -4207.558)","fill":"#e5ecf0"}}),_c('g',{attrs:{"data-name":"Groupe 1386"}},[_c('path',{attrs:{"data-name":"Tracé 6755","d":"M16772.926-4179.824c-5.633 0-10.079-6-10.228-6.225a.675.675 0 010-.889c.149-.226 4.596-6.226 10.228-6.226s10.08 6 10.231 6.225a.675.675 0 010 .889c-.151.223-4.6 6.226-10.231 6.226zm-8.669-6.67c1.112 1.334 4.6 5.188 8.671 5.188s7.629-3.858 8.67-5.188c-1.112-1.334-4.6-5.188-8.671-5.188s-7.634 3.854-8.67 5.188z","fill":"#044370"}})]),_c('g',{attrs:{"data-name":"Groupe 1387"}},[_c('path',{attrs:{"data-name":"Tracé 6756","d":"M16772.927-4182.788a3.706 3.706 0 113.706-3.706 3.67 3.67 0 01-3.706 3.706zm0-5.929a2.223 2.223 0 102.223 2.223 2.184 2.184 0 00-2.223-2.223z","fill":"#044370"}})])])])
          )
        }
      }
    